import { Filter } from '@anytag/shared-molecules';
import { Template, TemplateProps } from './Template';
import { useAutoManagedJoinedInfluencersFilter } from './hooks';

export type AutoManagedJoinedInfluencersFilterProps = Omit<TemplateProps, 'onSubmit'>;

export const AutoManagedJoinedInfluencersFilter = (props: AutoManagedJoinedInfluencersFilterProps) => {
  const { filter, setFilterForm } = useAutoManagedJoinedInfluencersFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template {...props} />
    </Filter.Provider>
  );
};

export { useAutoManagedJoinedInfluencersFilter };
export * from './schemaTypes';
